import setPrototypeOf from 'setprototypeof';
import { callApi, getApi } from './api';
import { Services } from './const';
import { NotFoundError, dataversionUpdateHandler as defaultDataversionUpdateHandler, } from './error-handling';
import { getFetchOptions } from './fetch';
import { getFullTenantPath } from './utils/get-full-tenant-path';
import { getUrl } from './utils/url';
export class ConfigurationInvalidError extends Error {
    constructor(message) {
        super(message);
        // fixes prototype chain, see https://goo.gl/0YcFxB
        setPrototypeOf(this, ConfigurationInvalidError.prototype);
    }
}
export async function getConfiguration(config, mockConfig, tenantPath, language, marketingCode, absolutPath = false) {
    const fullTenantPath = getFullTenantPath(tenantPath, language);
    const serviceUrl = `${fullTenantPath}/retrieveconfiguration/${marketingCode}.json`;
    const url = absolutPath
        ? serviceUrl
        : getUrl(config, mockConfig, `/${serviceUrl}`);
    let response;
    try {
        const options = getFetchOptions(config, mockConfig);
        response = await getApi(url, Services.RETREIVE_CONFIGURATION, options);
    }
    catch (e) {
        if (e instanceof NotFoundError) {
            throw new ConfigurationInvalidError();
        }
        throw e;
    }
    if (response.header.errors && response.header.errors.length > 0) {
        throw new ConfigurationInvalidError();
    }
    return response;
}
export async function storeConfiguration(config, mockConfig, dataversion, tenantPath, language, configuration, financeParameter, dataversionUpdateHandler = defaultDataversionUpdateHandler
// tslint:disable-next-line no-any
) {
    const { carlineId, salesGroupId, modelId, modelYear, modelVersion, exteriorId, interiorId, featureIds, } = configuration;
    const fullTenantPath = getFullTenantPath(tenantPath, language);
    const url = getUrl(config, mockConfig, `/${fullTenantPath}/` +
        `${dataversion}/storeconfiguration/${carlineId}/` +
        `${salesGroupId}/${modelId}/${modelYear}/${modelVersion}/` +
        `${exteriorId || '+'}/${interiorId || '+'}/${featureIds || '+'}/` +
        `${financeParameter ? 'CWEB' : '+'}/${financeParameter || '+'}/true/` +
        `${financeParameter ? 'true' : 'false'}.json`);
    const options = getFetchOptions(config, mockConfig);
    return dataversionUpdateHandler(callApi, url, Services.STORE_CONFIGURATION, options);
}
